import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import config from './config';

const userPool = new CognitoUserPool({
  UserPoolId: config.cognito.userPoolId,
  ClientId: config.cognito.clientId,
});

export const signIn = (email, password) => new Promise((resolve, reject) => {
  const user = new CognitoUser({ Username: email, Pool: userPool });
  const authDetails = new AuthenticationDetails({ Username: email, Password: password });
  user.authenticateUser(authDetails, {
    onSuccess: (session) => resolve(session.getIdToken().getJwtToken()),
    onFailure: reject,
    newPasswordRequired: (userAttributes) => {
      reject({ code: 'NewPasswordRequired', user, userAttributes });
    },
  });
});

export const signUp = (email, password, name) => new Promise((resolve, reject) => {
  const attrList = [
    { Name: 'email', Value: email },
    { Name: 'name', Value: name },
  ];
  userPool.signUp(email, password, attrList, null, (err, result) => {
    if (err) reject(err);
    else resolve(result);
  });
});

export const confirmSignUp = (email, code) => new Promise((resolve, reject) => {
  const user = new CognitoUser({ Username: email, Pool: userPool });
  user.confirmRegistration(code, true, (err, result) => {
    if (err) reject(err);
    else resolve(result);
  });
});

export const resendCode = (email) => new Promise((resolve, reject) => {
  const user = new CognitoUser({ Username: email, Pool: userPool });
  user.resendConfirmationCode((err, result) => {
    if (err) reject(err);
    else resolve(result);
  });
});

export const completeNewPassword = (user, newPassword) => new Promise((resolve, reject) => {
  user.completeNewPasswordChallenge(newPassword, {}, {
    onSuccess: (session) => resolve(session.getIdToken().getJwtToken()),
    onFailure: reject,
  });
});

export const changePassword = (oldPassword, newPassword) => new Promise((resolve, reject) => {
  const user = userPool.getCurrentUser();
  if (!user) { reject(new Error('Not signed in')); return; }
  user.getSession((err) => {
    if (err) { reject(err); return; }
    user.changePassword(oldPassword, newPassword, (err, result) => {
      if (err) reject(err);
      else resolve(result);
    });
  });
});

export const signOut = () => {
  const user = userPool.getCurrentUser();
  if (user) user.signOut();
  localStorage.removeItem('idToken');
  localStorage.removeItem('currentOrgId');
};

export const getToken = () => localStorage.getItem('idToken');
export const getOrgId = () => localStorage.getItem('currentOrgId');
export const setOrgId = (orgId) => localStorage.setItem('currentOrgId', orgId);
export const isAuthenticated = () => !!getToken();

export const isSuperAdmin = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return (payload['cognito:groups'] || []).includes('super_admins');
  } catch { return false; }
};
